import React, { Component } from "react";
import { Route as BasicRoute, Redirect, Switch } from "react-router";
import { BrowserRouter, Route } from "react-router-dom";

import WrapperFrame from "@configuratorware/configurator-frontendgui/App/Frame";

import combinedScreens from "@configuratorware/configurator-frontendgui/App/Screens";

import { getConf } from "@configuratorware/configurator-frontendgui/App/configuration.js";
import Overview from "./Containers/Overview/Overview";
import Basket from "./Containers/Basket/Basket";
import Thankyou from "./Components/Thankyou/Thankyou";
import ErrorBoundary from "./Components/ErrorBoundary/ErrorBoundary";

const NoMatch = () => <div>No routing found for the specified path.</div>;

const Routing = (props) => {
  const basePath = getConf("routingBasePath", "/");

  return (
    <BrowserRouter basename={basePath}>
      <ErrorBoundary>
        <WrapperFrame>
          <Switch>
            {/* <Route exact path="/" component={combinedScreens.Configurator} />

            <Redirect from="blank" to={basePath} /> */}

            <Route path="/products/overview" component={Overview} />

            <Route path="/basket/address" component={Basket} />

            <Route path="/thankyou" component={Thankyou} />

            <Route
              path="/identifier::identifier"
              component={combinedScreens.Configurator}
            />
            <Route
              path="/code::code"
              component={combinedScreens.Configurator}
            />

            <Route
              path="/widget/identifier::identifier"
              component={combinedScreens.CalculationWidget}
            />
            <Route
              path="/widget/code::code"
              component={combinedScreens.CalculationWidget}
            />

            <Route
              path="/designer-preview-widget"
              component={combinedScreens.DesignerProductPreview}
            />

            <Redirect to="/products/overview" />

            <Route component={NoMatch} />
          </Switch>
        </WrapperFrame>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routing;
